import React from 'react';

/**
 * Empty (outline only) star SVG uses the same path geometry that SWAN's
 * `<RatingsStars>` uses internally (extracted from
 * `@vp/swan/styles/ratings-stars.min.css`). Colour is pinned to SWAN's empty
 * ratings star component token.
 */
interface StarEmptySvgProps {
    size?: 'standard' | 'small';
}

const svgDimensions: Record<'standard' | 'small', { width: number; height: number }> = {
    standard: { width: 36, height: 32 },
    small: { width: 24, height: 24 },
};

export const StarEmptySvg = ({ size = 'standard' }: StarEmptySvgProps) => (
    <svg
        viewBox="0 -1 18 18"
        width={svgDimensions[size].width}
        height={svgDimensions[size].height}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
    >
        <path
            d="M8.65005 1.99999L10.0901 5.99999L10.3301 6.65999H15.2801L12.0001 9.15998L11.4601 9.56998L11.6501 10.23L12.8401 14.33L9.16006 12L8.62006 11.65L8.09006 12L4.41006 14.33L5.60006 10.23L5.79006 9.56998L5.25006 9.15998L2.00006 6.65999H7.00006L7.20006 5.99999L8.65005 1.99999ZM8.65005 -1.48384e-05C8.54479 -0.000844508 8.44243 0.0344525 8.36005 0.0999852C8.28402 0.152664 8.21656 0.21675 8.16006 0.289985L6.26006 5.65999H0.500055C0.396587 5.66047 0.295615 5.6918 0.210055 5.74999C0.122771 5.81712 0.0511173 5.90242 5.53359e-05 5.99999C-0.00994683 6.1131 -0.00994683 6.22687 5.53364e-05 6.33999C0.0461995 6.43785 0.11471 6.52348 0.200055 6.58999L4.64006 9.99998L3.06006 15.37C3.05002 15.4664 3.05002 15.5636 3.06006 15.66C3.10719 15.7544 3.17567 15.8366 3.26006 15.9C3.33016 15.9599 3.41801 15.995 3.51006 16C3.55952 16.0028 3.60903 15.9954 3.65549 15.9782C3.70195 15.9609 3.74435 15.9343 3.78006 15.9L8.60006 12.83L13.4301 15.9C13.5059 15.9634 13.6012 15.9987 13.7001 16C13.8084 16.0007 13.9139 15.9656 14.0001 15.9C14.0394 15.8726 14.0724 15.8369 14.0965 15.7954C14.1207 15.754 14.1356 15.7078 14.1401 15.66C14.1646 15.6156 14.1774 15.5657 14.1774 15.515C14.1774 15.4643 14.1646 15.4144 14.1401 15.37L12.6101 9.99998L17.0901 6.58999C17.167 6.52612 17.2199 6.43794 17.2401 6.33999C17.2646 6.29559 17.2774 6.2457 17.2774 6.19499C17.2774 6.14427 17.2646 6.09438 17.2401 6.04999C17.2199 5.95203 17.167 5.86385 17.0901 5.79999C17.0014 5.74045 16.8968 5.70908 16.7901 5.70999H11.0001L9.12006 0.289985C9.10275 0.214881 9.06043 0.147887 9.00006 0.0999852C8.91461 0.0330013 8.8086 -0.00233316 8.70006 -1.48384e-05H8.65005Z"
            fill="var(--swan-comp-ratings-stars-color-bg-empty, #d4620b)"
        />
    </svg>
);
